import { useEffect, useState } from 'react'

import { stringIsFalsy } from '../utils/string'
import useHiddenFormParams from './useHiddenFormParams'

const QUERY_OVERRIDE_KEY = 'debug'
const SESSION_OVERRIDE_KEY = 'uma:isDebug'

function useDebug() {
  const [isDebug, setIsDebug] = useState(false)
  const { mergeHiddenFormParams } = useHiddenFormParams()

  useEffect(() => {
    // get the query override if it's there
    const query = new URLSearchParams(window.location.search)
    const queryOverride = query.get(QUERY_OVERRIDE_KEY)

    // if there's a query override (for dev/qa testing), we need to set in
    // session storage to persist through session
    if (
      queryOverride !== null &&
      (queryOverride === '' || !stringIsFalsy(queryOverride))
    ) {
      sessionStorage.setItem(SESSION_OVERRIDE_KEY, 'true')
    } else if (queryOverride !== null && stringIsFalsy(queryOverride)) {
      sessionStorage.setItem(SESSION_OVERRIDE_KEY, 'false')
    }

    // now check the session value
    const sessionOverride = sessionStorage.getItem(SESSION_OVERRIDE_KEY)
    if (sessionOverride && sessionOverride === 'true') {
      mergeHiddenFormParams([{ default: 'Y', key: 'test' }])
      setIsDebug(true)
    } else if (sessionOverride && sessionOverride === 'false') {
      setIsDebug(false)
    }
  }, [mergeHiddenFormParams])

  return isDebug
}

export default useDebug
